import React from "react";
import DashboardCards from "./DashboardCards";
import DashboardGraph from "./DashboardGraph";
import CertificationGraph from "./CertificationGraph";
import TotalClosureGraph from "./TotalClosureGraph";
import TotalCompaniesGraph from "./TotalCompaniesGraph";
import YearlyGrowthGraph from "./YearlyGrowthGraph";

const Dashboard = () => {
  return (
    <div>
      <DashboardCards />
      <YearlyGrowthGraph />
      <TotalCompaniesGraph />
      <CertificationGraph />
      <TotalClosureGraph />
    </div>
  );
};

export default Dashboard;
